import { render, staticRenderFns } from "./joinTownDetail.vue?vue&type=template&id=87b513f6&scoped=true"
import script from "./joinTownDetail.vue?vue&type=script&lang=js"
export * from "./joinTownDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b513f6",
  null
  
)

export default component.exports